import { render, staticRenderFns } from "./EditStatus.vue?vue&type=template&id=47955cca"
import script from "./EditStatus.vue?vue&type=script&lang=js"
export * from "./EditStatus.vue?vue&type=script&lang=js"
import style0 from "./EditStatus.vue?vue&type=style&index=0&id=47955cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports